import { request } from "../../utils/config"
export const UPDATE_USER_PASSWORD = async (data) => {
  const response = await request({
    url: `Users`,
    method: "PUT",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const CREATE_USER = async (data) => {
  const response = await request({
    url: `Users`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
